<template>
	<div>
		<el-dialog
			title="添加联系人"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			append-to-body
			width="600px"
			:before-close="handleClose"
		>
			<el-form class="mt-10" :model="form" :rules="rules" ref="ruleForm" label-width="160px">
				<el-form-item label="添加方式" prop="add_type" key="add_type" v-if="isShowRadio">
					<div class="flex-row-align-center">
						<el-radio-group v-model="form.add_type" @change="changeFun">
							<el-radio style="margin-right: 2px" border v-model="form.add_type" label="1">新建联系人</el-radio>
							<el-radio border v-model="form.add_type" label="2">
								选择未绑定联系人
								<el-tooltip content="选择达人CRM中已经手动录入但还未绑定微信的联系人进行微信绑定" placement="bottom">
									<span>
										<i class="el-icon-question"></i>
									</span>
								</el-tooltip>
							</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<template v-if="form.add_type === '1'">
					<el-form-item label="微信号" prop="wechat_account" key="wechat_account">
						<el-input style="width: 285px" v-model="form.wechat_account" placeholder="请输入微信号" maxlength="32" />
					</el-form-item>
					<el-form-item label="名称" prop="contact_name" key="contact_name">
						<el-input style="width: 285px" v-model="form.contact_name" placeholder="请输入名称" />
					</el-form-item>
					<el-form-item label="手机号" prop="mobile" key="mobile">
						<el-input style="width: 285px" v-model="form.mobile" placeholder="请输入手机号" />
					</el-form-item>
					<el-form-item label="关联达人" prop="anchor_id" key="anchor_id">
						<template v-if="!anchorInfo">
							<dr-select style="width: 285px" v-model="form.anchor_id" :platformId="platformId" placehoder="请选择 / 搜索关联达人"></dr-select>
							<div class="font-h6-regular cursor-pointer mt-10 yx-color-primary" @click="goToPage">未找到达人？添加新的达人</div>
						</template>
						<template v-else>
							<div class="flex-row-align-center yx-background p-12 radius-4 yx-border">
								<div>
									<rd-img :size="60" class="mr-8" :src="anchorInfo.head"></rd-img>
								</div>
								<div style="width: 200px; line-height: 1; height: 60px" class="flex-column flex-just-between">
									<div class="flex-row-align-center">
										<i :class="calcIcon" class="mr-4"></i>
										<rd-text colorStyle="font-h6-medium" :value="anchorInfo.anchor_name" :width="130">{{ anchorInfo.anchor_name }}</rd-text>
										<level-tag class="ml-4" :lv="anchorInfo.anchor_level" />
									</div>
									<div class="color-gy-7 font-h6-regular">
										<span>{{ anchorInfo.platform_id | formatPlatformName('unify') }}：</span>
										<span>{{ anchorAccount(anchorInfo) }}</span>
									</div>
									<div>
										<rd-text color="#86909d" :value="anchorInfo?.recommend_type?.join('/')" :width="130">
											{{ anchorInfo?.recommend_type?.join('/') }}
										</rd-text>
									</div>
								</div>
							</div>
						</template>
					</el-form-item>
				</template>

				<template v-else>
					<el-form-item label="请选择 / 搜索达人" prop="selectDaren" key="selectDaren">
						<el-select
							style="width: 285px"
							v-model="dRname"
							:loading-text="loading_danRen"
							clearable
							:loading="loading_Dren_icon"
							filterable
							remote
							:remote-method="remoteMethod_daRen"
							@focus="focusFun_dRen"
							@change="selectFun"
							placeholder="请选择 / 搜索达人"
						>
							<template v-slot:prefix>
								<i class="el-icon-search ml-4"></i>
							</template>
							<!-- option 里的  anchor_account 不需要改 这个不是保持项-->
							<el-option
								v-for="(item, index) in darenOptions"
								:key="index"
								:value="item.anchor_account"
								:label="item.anchor_name"
								class="footer-option"
							>
								<div style="float: left" class="flex-row">
									<div class="footer-img ml-6 mr-6">
										<div>
											<span class="font-h4-regular">{{ item.anchor_name }}</span>
											<span class="fan">粉丝量：{{ item.fans_num }}</span>
										</div>
										<p class="douyin font-h4-regular">{{ platformId | formatPlatformName('unify') }}：{{ anchorAccount(item) }}</p>
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="请选择 / 搜索联系人" prop="anchor_contact_id" key="anchor_contact_id">
						<el-select
							style="width: 285px"
							:disabled="is_select_cont"
							v-model="form.anchor_contact_id"
							:loading-text="loading_cont"
							clearable
							filterable
							:loading="loadingContact_cont"
							remote
							:remote-method="remoteContactMethod_cont"
							@focus="focusContactFun_cont"
							@change="selectContactFun_cont"
							placeholder="请选择 / 搜索联系人"
						>
							<template v-slot:prefix>
								<i class="el-icon-search ml-4"></i>
							</template>
							<el-option v-for="(item, index) in contactOptions" :key="index" :value="item.id" :label="item.nick_name">
								<span class="contact-img"><img :src="item.avatar_url" alt="" /></span>
								<span class="contact-name">{{ item.nick_name }}</span>
							</el-option>
						</el-select>
					</el-form-item>
				</template>
				<el-form-item label="是否添加微信" prop="is_add_wx" key="is_add_wx">
					<el-radio-group v-model="form.is_add_wx" :disabled="Boolean(anchorInfo)">
						<el-radio style="margin-right: 2px" border label="1">是</el-radio>
						<el-radio border label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注" style="margin: 0" key="remark" v-if="form.add_type === '1'">
					<el-input
						type="textarea"
						:autosize="{ minRows: 3, maxRows: 4 }"
						:rows="3"
						maxlength="100"
						show-word-limit
						style="width: 285px"
						v-model="form.remark"
					/>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { addContactPerson, getPartnerAnchorList, bindContact, talentContact } from '@/api/talentCRM';
import DrSelect from '@/components/drSelect';
import { contactList, talentList } from '@/api/extenTecord';

// import { checkWx } from '@/utils/validate';

export default {
	name: 'addContactDialog',
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		anchorInfo: {
			// 达人详情时会把 anchorInfo 传递进来，有anchorInfo 后就不用选择关联达人了， 并且要把信息回显
			type: Object,
			default: null,
		},
	},
	components: {
		DrSelect,
	},
	data() {
		return {
			dialogVisible: false,
			dRname: '',
			talentList: [],
			imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
			form: {
				add_type: '1',
				wechat_account: '',
				contact_name: '',
				mobile: '',
				remark: '',
				anchor_id: '',
				anchor_contact_id: '',
				selectDaren: '',
				open_id: '0',
				is_add_wx: '1',
			},
			rules: {
				wechat_account: [
					{ required: true, message: '请输入微信号', trigger: 'blur' },
					// { required: true, validator: checkWx, trigger: 'blur' }
				],
				contact_name: { required: true, message: '请输入名称', trigger: 'change' },
				anchor_id: { required: true, message: '请选择关联达人', trigger: 'change' },
				anchor_contact_id: { required: true, message: '请选择联系人', trigger: 'change' },
				selectDaren: { required: true, message: '请选择达人', trigger: 'change' },
				is_add_wx: { required: true, message: '请选择', trigger: 'change' },
			},
			loading: false,
			loadingText: '加载中',
			loading_danRen: '加载中',
			darenOptions: [],
			danRenObj: {},
			loading_Dren_icon: false,
			contactOptions: [],
			ContactObj: {},
			loadingContact_cont: false,
			loading_cont: '加载中',
			is_select_cont: true,
			isShowRadio: 0,
			open_id: '0',
			PLATFORM_DY: dataMap.PLATFORM_DY.value,
		};
	},
	computed: {
		calcIcon() {
			return dataMap.PLATFORM_OBJ[this.platformId]?.icon;
		},
	},
	methods: {
		anchorAccount(item) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: item.anchor_account,
				[dataMap.PLATFORM_KS.value]: item.anchor_account,
				[dataMap.PLATFORM_SP.value]: item.anchor_uid,
				// [dataMap.PLATFORM_XHS.value]: item.anchor_account,
			};
			return temPF[this.platformId];
		},
		show(value, status) {
			if (value) {
				this.form.open_id = value;
			}
			this.getPartnerAnchorList();
			this.talentListFun();
			if (status) {
				this.isShowRadio = 1;
			} else {
				this.isShowRadio = 0;
			}
			this.dialogVisible = true;

			this.initData();
		},
		initData() {
			if (!this.anchorInfo) {
				return;
			}
			this.form.wechat_account = this.anchorInfo.wechat || this.anchorInfo.mobile;
			this.form.contact_name = this.anchorInfo.anchor_name;
			this.form.mobile = this.anchorInfo.mobile;
			this.form.anchor_id = this.anchorInfo.anchor_id;
			this.form.is_add_wx = '1';
		},
		async talentListFun() {
			const { code, data } = await talentList({ platform_id: this.platformId });
			if (code == 0) {
				this.darenOptions = data.list;
			}
		},
		//选择达人
		selectFun(e) {
			this.danRenObj = this.darenOptions.filter(item => {
				return item.anchor_account == e;
			})[0];
			this.form.selectDaren = this.danRenObj?.id;
			this.is_select_cont = !e;
			// 清空达人后同时清空联系人
			if (!e) {
				this.ContactObj = {};
				this.form.anchor_contact_id = '';
			}
		},
		//远程搜索
		async remoteMethod_daRen(e) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { code, data } = await talentList({ platform_id: this.platformId, anchor_name: e });
			this.loading_Dren_icon = false;
			if (code == 0) {
				this.darenOptions = data.list;
			}
		},
		async focusFun_dRen(e) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { code, data } = await talentList({ platform_id: this.platformId, anchor_name: e.target.value });
			if (code == 0) {
				this.darenOptions = data.list;
				data.list.length ? (this.loading_Dren_icon = false) : (this.loading_danRen = '无数据');
			}
		},
		//联系人远程搜索
		async remoteContactMethod_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({
				anchor_id: this.form.selectDaren,
				nick_name: e,
				unbind_wechat: this.isShowRadio ? '1' : '',
			});
			this.loadingContact_cont = false;
			if (code == 0) {
				this.contactOptions = data.list;
			}
		},
		async focusContactFun_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({
				anchor_id: this.form.selectDaren,
				nick_name: e.target.value,
				unbind_wechat: this.isShowRadio ? '1' : '',
			});
			if (code == 0) {
				this.contactOptions = data.list;
				data.list.length ? (this.loadingContact_cont = false) : (this.loading_cont = '无数据');
			}
		},
		//选择联系人
		selectContactFun_cont(e) {
			this.ContactObj = this.contactOptions.filter(item => {
				return item.id == e;
			})[0];
		},
		async getPartnerAnchorList() {
			const { code, data: { list = [] } = {} } = await getPartnerAnchorList();
			if (code !== 0) return;
			this.talentList = list;
		},
		handleClose() {
			this.dialogVisible = false;
			this.form = {
				add_type: '1',
				wechat_account: '',
				contact_name: '',
				anchor_contact_id: '',
				selectDaren: '',
				mobile: '',
				remark: '',
				anchor_id: '',
				open_id: '0',
				is_add_wx: '1',
			};
			this.talentList = [];
			this.$refs.ruleForm.resetFields();
		},
		submit() {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				if (this.form.add_type === '1') {
					const { code, data } = await addContactPerson(this.form);
					if (code !== 0) return;
					const id = data.id;
					const params = {
						id,
						contact_type: 1,
						anchor_id: this.form.anchor_id,
						is_add_wx: this.form.is_add_wx,
						is_pass: 1,
						operate_time: Math.trunc(new Date().getTime() / 1000),
					};
					const talentContactRes = await talentContact(params);
					if (talentContactRes.code !== 0) return;
				} else {
					const { code } = await bindContact(this.form);
					if (code !== 0) return;
				}

				this.$message.success('添加成功');
				this.handleClose();
				this.$emit('getList');
			});
		},
		async goToPage() {
			const handLink = this.$router.resolve({
				path: `/talentCRM/myTalent`,
			});
			window.open(handLink.href, '_blank');
		},
		//远程搜索
		async remoteMethod(e) {
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await getPartnerAnchorList({ anchor_name: e });
			this.loading = false;
			if (code == 0) {
				this.talentList = data.list;
			}
		},
		async focusFun(e) {
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await getPartnerAnchorList({ anchor_name: e.target.value });
			if (code == 0) {
				this.talentList = data.list;
				data.list.length ? (this.loading = false) : (this.loadingText = '无数据');
			}
		},
		changeFun(e) {
			if (e === '2') {
				this.dRname = '';
			} else {
				this.ContactObj = {};
				this.form.anchor_contact_id = '';
				this.is_select_cont = true;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.bind {
	margin-bottom: 3px;
}

.footer-img {
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
	}
}

.footer-option {
	padding: 8px 0px;
	height: auto !important;
	line-height: initial;
}

.douyin {
	margin-top: 2px;
	color: @color-gy7;
	font-size: 12px;
}

.fan {
	flex: 1;
	white-space: nowrap;
	height: 20px;
	color: #fdd2a1;
	font-size: 12px;
	padding: 1px 2px;
	margin-left: 5px;
	border: 1px solid #fdd2a1;
}

.contact-img {
	float: left;
	width: 30px;
	height: 30px;
}

.contact-img img {
	border-radius: 50%;
}

.contact-name {
	float: left;
	color: #8492a6;
	margin-left: 10px;
}
/deep/ .el-radio--small.is-bordered .el-radio__label {
	font-size: 14px;
}
</style>
